import React, { useEffect, useState, useContext } from "react";
import ProjectContext from "../../../ProjectContext";
import customizationsV2Service from "../../../services/api/customizations-v2-service";
import projectsService from "../../../services/api/projects-service";
import { useHistory, Link } from "react-router-dom";
import Moment from "react-moment";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Spinner,
    Table,
    Container,
    Row,
    Col,
} from "reactstrap";

const AppConfigV2Version = (props) => {
    const projectDetails = useContext(ProjectContext);
    const history = useHistory();
    const platform = new URLSearchParams(props.location.search).get("platform") || "android";
    const projectId = projectDetails.id || "";

    const [configVersions, setConfigVersions] = useState([]);
    const [projectName, setProjectName] = useState("");
    const [componentRendered, setComponentRendered] = useState(false);
    const [reloadComponent, setReloadComponent] = useState(0);

    useEffect(() => {
        if (!projectDetails.id) {
            return;
        }
        if (!projectDetails.isV2enabled) {
            history.push("/apps/manager");
            return;
        }
        const platformEnabled =
            (platform === "android" && projectDetails.android_app_enabled) ||
            (platform === "ios" && projectDetails.ios_app_enabled);
        if (!platformEnabled) {
            history.push("/apps/manager");
        }
    }, [projectDetails, platform, history]);

    useEffect(() => {
        if (!projectId) {
            return;
        }
        let isMounted = true;
        (async () => {
            try {
                const projectDetailsResponse = await projectsService.getProjectDetails(projectId);
                if (isMounted && projectDetailsResponse.status && projectDetailsResponse.data) {
                    setProjectName(projectDetailsResponse.data.name);
                }

                const versionsResponse = await customizationsV2Service.getAppV2ConfigVersions(projectId, platform);
                if (isMounted && versionsResponse.status && versionsResponse.data) {
                    setConfigVersions(versionsResponse.data.versions || []);
                }
            } catch (error) {
                console.error("Error fetching app config versions:", error);
            } finally {
                if (isMounted) {
                    setComponentRendered(true);
                }
            }
        })();
        return () => {
            isMounted = false;
        };
    }, [reloadComponent, projectId, platform]);

    if (!projectDetails.id) {
        return null;
    }

    const platformLabel = platform === "ios" ? "iOS" : "Android";

    return (
        <div className="content">
            <Container>
                <Row>
                    <Col className="ml-auto mr-auto" md="12">
                        <Card className="card-signup text-center">
                            <CardHeader>
                                <CardTitle tag="h4">
                                    {platformLabel} V2 App Config — {projectName}
                                </CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Table responsive>
                                    <thead className="text-primary">
                                        <tr>
                                            <th className="text-left">#</th>
                                            <th className="text-left">Name</th>
                                            <th className="text-left">Created At</th>
                                            <th className="text-left">Updated At</th>
                                            <th className="text-left">Modified By</th>
                                            <th className="text-left">Engine Version</th>
                                            <th className="text-left">Published</th>
                                            <th className="text-left">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {configVersions.length === 0 ? (
                                            !componentRendered ? (
                                                <tr>
                                                    <td colSpan="8" className="text-center">
                                                        <Spinner animation="border" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </Spinner>
                                                    </td>
                                                </tr>
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center">
                                                        <CardTitle tag="h4">No Records Found</CardTitle>
                                                    </td>
                                                </tr>
                                            )
                                        ) : (
                                            configVersions.map((configVersion, index) => (
                                                <tr key={index} className={!configVersion.status ? "table-danger" : ""}>
                                                    <td className="text-left">{index + 1}</td>
                                                    <td className="text-left">{configVersion.name || ""}</td>
                                                    <td className="text-left">
                                                        <Moment format="DD MMM YYYY hh:mm:ss a">{configVersion.createdAt}</Moment>
                                                    </td>
                                                    <td className="text-left">
                                                        <Moment format="DD MMM YYYY hh:mm:ss a">{configVersion.updatedAt}</Moment>
                                                    </td>
                                                    <td className="text-left">{configVersion.modified_by || "System"}</td>
                                                    <td className="text-left">{configVersion.engine_version || ""}</td>
                                                    <td className="text-left">{configVersion.is_published ? "Yes" : "No"}</td>
                                                    <td className="text-left">
                                                        <Link
                                                            to={{
                                                                pathname: "/apps/config/v2/customizations",
                                                                search: projectDetails.slug
                                                                    ? `?project=${projectDetails.slug}&version=${configVersion.version}&platform=${platform}`
                                                                    : `?version=${configVersion.version}&platform=${platform}`,
                                                            }}
                                                        >
                                                            <Button className="btn-round btn-primary" color="primary" size="sm" type="button">
                                                                Edit
                                                            </Button>
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AppConfigV2Version;
